import { render, staticRenderFns } from "./PrivilegeInfo.vue?vue&type=template&id=1e45cbbf&"
import script from "./PrivilegeInfo.vue?vue&type=script&lang=js&"
export * from "./PrivilegeInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeInfo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports